import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { Logger } from 'src/app/core/interfaces/Logger';
import { Permission } from '../../domain/models/permission.model';
import { PermissionGroup } from '../../domain/models/permission-group.model';
import { PermissionRepositoryPort } from '../../domain/ports/permission.repository.port';
import { PermissionGateway } from '../gateway/permission.gateway';
import { PermissionMapper } from '../mappers/permission.mapper';
import { PermissionGroupMapper } from '../mappers/permission-group.mapper';

@Injectable({ providedIn: 'root' })
export class HttpPermissionRepositoryAdapter implements PermissionRepositoryPort {
  private readonly gateway = inject(PermissionGateway);
  private readonly logger = inject(Logger);

  fetchPermissions(): Observable<Permission[]> {
    return this.gateway.getPermissions().pipe(
      map(dtos => PermissionMapper.toDomainArray(dtos)),
      catchError(error => {
        this.logger.error(
          new Error('[HttpPermissionRepositoryAdapter][fetchPermissions] Error fetching permissions'),
          error
        );

        return of([]);
      })
    );
  }

  fetchPermissionGroups(organizationId: string): Observable<PermissionGroup[]> {
    return this.gateway.getPermissionGroups(organizationId).pipe(
      map(dtos => PermissionGroupMapper.toDomainArray(dtos)),
      catchError(error => {
        this.logger.error(
          new Error('[HttpPermissionRepositoryAdapter][fetchPermissionGroups] Error fetching permission groups'),
          error
        );

        return of([]);
      })
    );
  }
}